export default __webpack_public_path__ + "static/media/forest02.41ecbd10.jpeg";